// extracted by mini-css-extract-plugin
export default {"logoWrapper":"SideNav_logoWrapper__3dM9b","logo":"SideNav_logo__LaJdG"};